import { AnchorHTMLAttributes, ButtonHTMLAttributes } from "react";
import { cva, VariantProps } from "class-variance-authority";
import { Link } from "react-router-dom";

type ButtonBaseProps = VariantProps<typeof buttonClasses> & {
  children: React.ReactNode;
};
interface ButtonAsAnchorProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
}
interface ButtonAsButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  href?: never;
}

type ButtonProps = ButtonBaseProps &
  (ButtonAsAnchorProps | ButtonAsButtonProps);

const buttonClasses = cva("transition-colors active:scale-[0.99] font-medium", {
  variants: {
    variant: {
      // primary: [
      //   "inline-flex",
      //   "bg-primary-bg",
      //   "text-white",
      //   "hover:text-hot-pink",
      //   "border-b-2",
      //   "border-hot-pink",
      // ],
      // secondary: [
      //   "block",
      //   "bg-hot-pink",
      //   "hover:bg-secondary-hover",
      //   "text-white",
      // ],
      // disabled: [
      //   "inline-flex",
      //   "pointer-events-none",
      //   "bg-button-gray",
      //   "border",
      //   "border-black",
      //   "opacity-50",
      //   "grayscale",
      // ],
      primary: ["bg-hot-pink", "hover:bg-secondary-hover", "text-white"],
      secondary: [
        "bg-white",
        "text-black",
        "border",
        "border-black",
        "hover:bg-gray-300",
      ],
      disabled: [
        "pointer-events-none",
        "bg-button-gray",
        "border",
        "border-black",
        "opacity-50",
        "grayscale",
      ],
    },
    size: {
      small: "text-xs py-1 px-2",
      medium: "text-sm py-2 px-4",
      large: "text-md py-3 px-5",
    },
  },
  defaultVariants: {
    variant: "primary",
    size: "medium",
  },
});

export default function Button({
  children,
  variant,
  size,
  ...props
}: ButtonProps) {
  const classes = buttonClasses({ variant, size, className: props.className });

  if ("href" in props && props.href !== undefined) {
    const { href, ...rest } = props as ButtonAsAnchorProps;
    return (
      <Link to={href} {...rest} className={classes}>
        {children}
      </Link>
    );
  }

  return (
    <button {...props} className={classes}>
      {children}
    </button>
  );
}
